import { SvgIcon, SxProps } from "@mui/material";
import LinkSvg from "jsx:../../../Images/Icons/FontAwesome/solid/link.svg";

export function LinkSolidIcon(props: SxProps) {
    return <SvgIcon component={LinkSvg} inheritViewBox sx={props} />;
}
